import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAlertPopup } from 'hooks/useAlertPopup';
import { usePopup } from 'hooks/usePopup';

import { getUnsafeImageUrls, isUnsafeItemTitleError } from './isUnsafeItemContentError';
import ItemErrorPopup from './ItemErrorPopup';

export const useItemError = () => {
  const { showPopup, hidePopup } = usePopup();
  const { showAlertPopup } = useAlertPopup();
  const { t } = useTranslation('addItem');
  const navigate = useNavigate();

  const handleContactSupport = () => {
    hidePopup(true);
    navigate('/messenger/support');
  };

  const showAddItemUnsafeTitlePopup = () => {
    showAlertPopup({
      header: t('error.unsafe-title-title'),
      description: t('error.unsafe-title'),
      firstButton: { label: t('common:ok') },
      testId: 'item-unsafe-title-alert',
    });
  };

  const showAddItemUnsafePhotosPopup = () => {
    showAlertPopup({
      header: t('common:sorry'),
      description: t('error.unsafe-photos'),
      firstButton: { label: t('common:ok') },
      testId: 'item-unsafe-photos-alert',
    });
  };

  const showAddItemErrorPopup = (error?: unknown, removeUnsafePhotos?: (urls: string[]) => void) => {
    if (isUnsafeItemTitleError(error)) {
      showAddItemUnsafeTitlePopup();
      return;
    }

    const unsafeImageUrls = getUnsafeImageUrls(error);
    if (unsafeImageUrls.length > 0) {
      removeUnsafePhotos?.(unsafeImageUrls);
      showAddItemUnsafePhotosPopup();
      return;
    }

    showPopup(<ItemErrorPopup message={t('error.unable-to-list')} onContactPress={handleContactSupport} />, {
      keepPopups: true,
    });
  };

  const showDeleteItemErrorPopup = () => {
    showPopup(<ItemErrorPopup message={t('error.unable-to-delete')} onContactPress={handleContactSupport} />, {
      keepPopups: true,
    });
  };

  return { showAddItemErrorPopup, showDeleteItemErrorPopup };
};
